module.exports = __webpack_public_path__ + "static/media/sanguo-3.0596a065.png";